import React, { useRef } from "react";

export function Portal() {
  const el = useRef(document.createElement("div"));

  return <div ref={el} id={"react-portal"} />;
}
